export const INITIAL_PAGE_SIZE = 500;
export const CHILDREN_PAGE_SIZE = 100;
export const PAGE_TREE_SSR_RENDER_SIZE_LIMIT = 300;

export const getPageTreeSSRRenderSizeLimit = () =>
	process.env.NODE_ENV === 'production' ? PAGE_TREE_SSR_RENDER_SIZE_LIMIT : 0;
